import { updateReportLoss } from "../report/actions";
import {
  UPDATE_REPORT_LOSS_FAIL,
  UPDATE_REPORT_LOSS_REQUEST,
} from "../report/actionType";
import axios from "./utils/axios";

const fetchUpdateReportLoss = (orderNumber, loss_report) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_REPORT_LOSS_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `api/report/update_loss_report/${orderNumber}/`,
        loss_report,
        config
      );
      dispatch(updateReportLoss(data));
    } catch (error) {
      dispatch({
        type: UPDATE_REPORT_LOSS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });
    }
  };
};
export default fetchUpdateReportLoss;
